import React, { useState } from 'react';

import useSearchParams, { useLocation } from 'react-router-dom';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const ResetPasswordPage: React.FC = () => {
  const query = useQuery();
  const token = query.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!password || !confirmPassword) {
      setError('Please fill in both fields');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/reset-password`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
        body: JSON.stringify({
          token,
          newPassword: password,
        }),
      });

      const result = await res.json();

      if (res.ok) {
        setMessage('Your password has been reset successfully.');
        setError('');
      } else {
        setError(result.message || 'Invalid or expired token');
      }
    } catch (err) {
      setError('Network error');
    }
  };

  return (
    <main className="main-bg">
      <div className="small-container add-yolo-info text-center">
        <div
          className="start-row d-flex full-height align-items-center"
          style={{ flexDirection: 'column', paddingTop: '0px' }}
        >
          <h2 className="futuralt-book mt-4 pt-2 mb-4">Reset Your Password</h2>

          <input
            type="password"
            className="field md-filed text-center"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px'
            }}
          />

          <input
            type="password"
            className="field md-filed text-center mt-2"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{
              boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px'
            }}
          />

          {message && <p style={{ color: 'green', marginTop: '10px' }}>{message}</p>}
          {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}

          <input
            type="button"
            className="btn-primary mt-4 "
            value="Reset Password"
            onClick={handleSubmit}
          />
          <input
            type="button"
            className="btn-primary mt-4 "
            value="Back to YoloMeal!"
            onClick= {() => window.location.href = '/home'}
          />

        </div>
      </div>
    </main>
  );
};

export default ResetPasswordPage;
